import React from "react";
import {
  Box,
  Paper,
  Typography,
  CircularProgress,
  Divider,
  Button,
} from "@material-ui/core";
// import { CheckCircle, Cancel, Redo } from "@material-ui/icons";
import { useHistory } from "react-router-dom";

import "./exam-result-overview.scss";

const ExamResultOverview = (props) => {
  const { quizOverview, quizDetails } = props;
  const history = useHistory();

  const goToOverallPerformance = () => {
    history.push(`/overall-performance`);
  };

  const hours = Math.floor((quizOverview?.quizDuration / (60 * 60)) % 24);
  const mins = Math.floor((quizOverview?.quizDuration / 60) % 60);
  const sec = Math.floor(quizOverview?.quizDuration % 60);

  return (
    <Paper elevation={3}>
      <Box component="div" className="quiz-details">
        <Box component="div" className="quiz-details-content">
          {/* C13: human H1 leads; the machine quiz name + flags + completion
              date are demoted into the small metadata block below it. */}
          <Typography variant="h1" className="quiz-result-title">
            Quiz Results
          </Typography>
          <Box component="div" className="quiz-meta">
            <Box component="div" className="quiz-meta-name">
              {quizDetails?.name}
            </Box>
            <Box component="div" className="quiz-text">
              Tutor {quizDetails?.tutorOn ? "On" : "Off"} · Timer
              {quizDetails?.timerOn ? " On" : " Off"}
            </Box>
            <Box component="div" className="quiz-text">
              Completed: {quizOverview?.quizSubmitDate
                ? new Date(quizOverview.quizSubmitDate).toLocaleString()
                : "—"}
            </Box>
          </Box>
        </Box>
      </Box>
      <Divider />
      <Box component="div" className="quiz-result-numbers">
        <Box component="div" className="quiz-percent-cont">
          {/* C5: the score % is the single big number (kept in the ring). */}
          <Box component="div" className="quiz-percent-progress">
            <CircularProgress
              variant="determinate"
              className="circular-progress-bkg"
              thickness={2}
              value={100}
            />
            <CircularProgress
              variant="determinate"
              thickness={2}
              value={quizOverview?.correctPercentage ?? 0}
            />
            <Box component="div" className="quiz-progress-text">
              <Box component="div" className="quiz-progress-text-num">
                {quizOverview?.correctPercentage ?? 0}%
              </Box>
              Correct
            </Box>
          </Box>
          {/* C5: INCORRECT % + raw fraction collapse into ONE caption,
              counting CORRECT (never under an INCORRECT headline). */}
          <Box component="div" className="quiz-result-caption">
            {quizOverview?.questionCorrectCount ?? 0} of{" "}
            {quizOverview?.questionAttemptCount ?? 0} correct
          </Box>
        </Box>
        {/* C2: TOTAL TIME only for timed quizzes — untimed shows nothing
            (no meaningless "00m 00s"). C5: TOTAL QUESTIONS tile dropped. */}
        {quizDetails?.timerOn && (
          <Box component="div" className="quiz-percent-total">
            <Typography variant="body2" display="block">
              Total time
            </Typography>
            <Typography variant="h6">
              <span>
                {hours > 0 && hours < 10 && <>0{hours}h </>}
                {hours >= 10 && <>{hours}h </>}
              </span>
              <span>
                {mins >= 0 && mins < 10 && <>0{mins}m </>}
                {mins >= 10 && <>{mins}m </>}
              </span>
              <span>
                {sec >= 0 && sec < 10 && <>0{sec}s</>}
                {sec >= 10 && <>{sec}s</>}
              </span>
            </Typography>
          </Box>
        )}
      </Box>
      {/* C12: full-width sentence-case secondary action under the card. */}
      <Box component="div" className="quiz-details-btn-cont">
        <Button
          variant="outlined"
          fullWidth
          onClick={goToOverallPerformance}
        >
          View overall performance
        </Button>
      </Box>
    </Paper>
  );
};

export default ExamResultOverview;
